import { useState } from 'react'

import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { IconButton, Snackbar } from '@mui/material'

interface CopyToClipboardIconButtonProps {
  text: string
}

const CopyToClipboardIconButton = ({ text }: CopyToClipboardIconButtonProps) => {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
    navigator.clipboard.writeText(text)
  }

  return (
    <>
      <IconButton
        aria-label="copy"
        onClick={handleClick}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&:focus': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <ContentCopyIcon fontSize="small" sx={{ color: 'primaryColors.actionGrey' }} />
      </IconButton>
      <Snackbar open={open} onClose={() => setOpen(false)} autoHideDuration={2000} message="Copied to clipboard" />
    </>
  )
}

export default CopyToClipboardIconButton
